__turbopack_context__.v({
  "className": "archivo_1fcae3bd-module__sQvn5a__className",
});
